import { render } from "./SurveyTableDev.vue?vue&type=template&id=15b27fc2&scoped=true"
import script from "./SurveyTableDev.vue?vue&type=script&lang=js"
export * from "./SurveyTableDev.vue?vue&type=script&lang=js"

import "./SurveyTableDev.vue?vue&type=style&index=0&id=15b27fc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b27fc2"]])

export default __exports__